import React, { Component } from 'react';
import imgPaypal from '../assets/don.gif'

export default class Paypal extends Component {

    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.refs.paypalImg.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            this.refs.paypalForm.submit();
        })
    }
    render() {
        const styleImg = {
            position: "fixed",
            bottom: "0px",
            right: "0px",
            cursor: "pointer"
        }
        const styleForm = {
            display: "none"
        }
        return (
            <div>
                <form
                    action="https://www.paypal.com/cgi-bin/webscr"
                    method="post"
                    target="_top"
                    ref="paypalForm"
                    style={styleForm}>
                    <input
                        type="hidden"
                        name="cmd"
                        value="_s-xclick"/>
                    <input
                        type="hidden"
                        name="hosted_button_id"
                        value="Q2XYVFP4EEX2J"/>
                    <input
                        type="image"
                        name="submit"/>
                </form>
                <img
                    src={imgPaypal}
                    style={styleImg}
                    ref="paypalImg"
                    title="Si vous pensez que cet outil le mérite... Merci !"
                    alt="Faire un don"/>
            </div>
    );
  }
}
